import { Button, ButtonSize, ButtonVariant, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import { useTranslation } from "@next-platform/client-common-core";
import React from "react";

import Trans from "@/components/Trans/Trans";
import { PresetSaveDialogProps } from "@/pages/Chat/components/ModalGenerationSettings/PresetsManager/types";

export function PresetSaveDialog({ presetName, onNameChange, onSave, onCancel, isDisabled, isSaving, duplicateError }: PresetSaveDialogProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-2 p-3 border border-gray-6 rounded-md bg-gray-2 dark:bg-gray-5">
      <Text variant={TextVariants.LABEL_SMALL_MEDIUM} className="text-gray-12">
        <Trans i18nKey="chat:modal.generationSettings.presets.saveCurrentSettings" />
      </Text>
      {duplicateError && (
        <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-red-9 text-xs">
          <Trans i18nKey="chat:modal.generationSettings.presets.duplicateError" />
        </Text>
      )}
      <input
        type="text"
        value={presetName}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onNameChange(e.target.value)}
        placeholder={t("chat:modal.generationSettings.presets.enterPresetName")}
        className="px-2 py-1.5 rounded border border-gray-6 bg-gray-1 dark:bg-gray-3 text-gray-12 text-sm focus:outline-none focus:ring-2 focus:ring-purple-9"
        autoFocus
        disabled={isDisabled || isSaving}
      />
      <div className="flex flex-row gap-2">
        <Button size={ButtonSize.SMALL} variant={ButtonVariant.OUTLINED} onClick={onCancel} disabled={isDisabled || isSaving}>
          <Trans i18nKey="common:cancel" />
        </Button>
        <Button size={ButtonSize.SMALL} onClick={onSave} disabled={isDisabled || isSaving || !presetName.trim()}>
          {isSaving ? (
            <Trans i18nKey="chat:modal.generationSettings.presets.saving" />
          ) : (
            <Trans i18nKey="chat:modal.generationSettings.presets.savePreset" />
          )}
        </Button>
      </div>
    </div>
  );
}
